module.exports = __webpack_public_path__ + "media/bootstrap-icons/hammer-299066c8.svg";